/* @flow */
import React from 'react';
import { Spin } from 'antd';
import styles from './Loader.module.pcss';

type Props = {
  size: 'small' | 'default' | 'large',
};

const Loader = ({ size }: Props) => (
  <div className={styles.loader}>
    <Spin size={size} />
  </div>
);

export default Loader;
